(function () {
	// Delegated: Combined Listing swaps description/about markup; bind on document instead of static nodes.
	$(document).on(
		"click.productAbout keydown.productAbout",
		".product-about__accordion-title",
		function (event) {
			if (event.type === "keydown" && event.key !== "Enter") return;

			const $title = $(this);
			const $root = $title.closest(".product-about");
			const $content = $title
				.closest(".product-about__accordion-item")
				.find(".product-about__accordion-content")
				.first();

			if (!$content.length) return;

			if (!$title.hasClass("active")) {
				$root.find(".product-about__accordion-title.active").removeClass("active");
				$title.addClass("active");
				$root.find(".product-about__accordion-content").stop().slideUp(200);
				$content.stop().slideDown(200);
			} else {
				$title.removeClass("active");
				$content.stop().slideUp(200);
			}
		},
	);
})();
